<body>
    <div class="grid-overlay">
        <app-page-header></app-page-header>
        <div class="question-content">
            <h1 class="main-title">{{ 'faqs.title' | translate }}</h1>
            <div class="faqs">
                <div class="header">
                    <div class="title">
                        <img src="../../assets/icons/informacion2.png" alt="icono de informacion">
                        <h1>{{ 'faqs.section.title' | translate }}</h1>
                    </div>
                    <!--
                    <img src="../../assets/icons/cerrar.png" (click)="onCloseModal()" alt="cerrar el modal"
                        class="close">-->
                </div>
                <div class="question-grid">
                    <div class="left">
                        <div class="item-question">
                            <h4>{{ 'faqs.questions.multipleUsers.question' | translate }}</h4>
                            <p>{{ 'faqs.questions.multipleUsers.answer' | translate }}</p>
                        </div>
                        <div class="item-question">
                            <h4>{{ 'faqs.questions.maxPortals.question' | translate }}</h4>
                            <p>{{ 'faqs.questions.maxPortals.answer' | translate }}</p>
                        </div>
                        <div class="item-question">
                            <h4>{{ 'faqs.questions.affiliationPlan.question' | translate }}</h4>
                            <p>{{ 'faqs.questions.affiliationPlan.answer' | translate }}</p>
                        </div>
                    </div>
                    <div class="right">
                        <div class="item-question">
                            <h4>{{ 'faqs.questions.multipleUsers.question' | translate }}</h4>
                            <p>{{ 'faqs.questions.multipleUsers.answer' | translate }}</p>
                        </div>
                        <div class="item-question">
                            <h4>{{ 'faqs.questions.maxPortals.question' | translate }}</h4>
                            <p>{{ 'faqs.questions.maxPortals.answer' | translate }}</p>
                        </div>
                        <div class="item-question">
                            <h4>{{ 'faqs.questions.affiliationPlan.question' | translate }}</h4>
                            <p>{{ 'faqs.questions.affiliationPlan.answer' | translate }}</p>
                        </div>
                    </div>
                </div>
                <div class="more-info">
                    <h1>{{ 'faqs.moreInfo.title' | translate }}</h1>
                    <div class="content-info">
                        <img src="../../assets/icons/big-info.png" alt="icono de informacion blanco">
                        <div class="text">
                            <h1>{{ 'faqs.moreInfo.subtitle' | translate }}</h1>
                            <p>{{ 'faqs.moreInfo.description' | translate }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="button-option">
            <p>{{ 'faqs.contact.question' | translate }}</p>
            <button>{{ 'faqs.contact.button' | translate }}</button>
        </div>
    </div>
</body>